import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  PasswordButtonText,
  PasswordEditButton,
  PasswordWrapper,
  ProfileSectionPhoneTitle,
  ProfileSectionPhoneWrapper,
  ProfileSectionTitle,
} from 'Features/userProfile/components/ProfileSection/ProfileSection.styled'
import { InputWithTitle, theme } from '@clickcease/cc-client-components-lib'
import {
  FieldsWrapper,
  UserProfileSection,
} from 'Features/userProfile/routes/UserProfile/UserProfile.styled'
import { useGetUserProfile } from 'Features/userProfile/api/getUserProfile'
import { useUpdateUserProfile } from 'Features/userProfile/api/updateUserProfile'
import { EditBoard } from 'Assets/icons/EditBoard'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { shallow } from 'zustand/shallow'
import { ChangePasswordModal } from 'Features/userProfile/components/ChangePasswordModal/ChangePasswordModal'

export const ProfileSection = () => {
  const { t } = useTranslation('userProfile')
  const [fullName, setFullName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [showChangePasswordModal, setShowChangePasswordModal] = useState<boolean>(false)
  const { mutate } = useUpdateUserProfile()
  const userQuery = useGetUserProfile()
  const { showToaster } = useAppStore(
    (state) => ({
      showToaster: state.showToaster,
    }),
    shallow
  )

  const userData = useMemo(() => {
    if (!(userQuery.data instanceof Error)) {
      return userQuery.data
    }
  }, [userQuery])

  const updateField = (type: string, value: string | number) => {
    if (value !== userData?.[type]) {
      mutate(
        { type, value },
        {
          onSuccess: () => showToaster(t('successfully_updated'), 'success'),
          onError: () => showToaster(t('updating_error'), 'failure'),
        }
      )
    }
  }

  useEffect(() => {
    if (userData) {
      setFullName(userData.fullName)
      setPhone(userData.phoneNumber)
    }
  }, [userData])

  const phoneInputStyle = { borderColor: theme.colors.lightGray.value, height: '33px' }
  const inputWidth = { width: '250px' }

  return (
    <UserProfileSection id={'user-profile-general-section'}>
      <ProfileSectionTitle>{t('profile')}</ProfileSectionTitle>
      <FieldsWrapper>
        <InputWithTitle
          style={inputWidth}
          title={t('name')}
          value={fullName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setFullName(e.target.value)
          }}
          onBlur={() => {
            updateField('fullName', fullName)
          }}
        />
        <InputWithTitle
          style={inputWidth}
          title={t('email')}
          disabled={true}
          value={userData?.email ?? ''}
        />
        <ProfileSectionPhoneWrapper>
          <ProfileSectionPhoneTitle>{t('phone')}</ProfileSectionPhoneTitle>
          <PhoneInput
            placeholder=" "
            containerClass="phone-input-container"
            preferredCountries={['us', 'gb', 'fr']}
            country={'us'}
            onChange={(value) => setPhone(value)}
            onBlur={() => {
              updateField('phoneNumber', phone)
            }}
            inputStyle={phoneInputStyle}
            buttonStyle={phoneInputStyle}
            value={phone}
          />
        </ProfileSectionPhoneWrapper>
        <PasswordWrapper>
          <InputWithTitle
            title={t('password')}
            inputType="password"
            value="*******"
            style={inputWidth}
            onChange={() => {}}
          />
          <PasswordEditButton
            onClick={() => {
              setShowChangePasswordModal(true)
            }}
          >
            <EditBoard />
            <PasswordButtonText>{t('edit_password')}</PasswordButtonText>
          </PasswordEditButton>
        </PasswordWrapper>
        <ChangePasswordModal
          onCloseClick={() => {
            setShowChangePasswordModal(false)
          }}
          isOpen={showChangePasswordModal}
        />
      </FieldsWrapper>
    </UserProfileSection>
  )
}
